export const extractErrorMessage = error => {
  console.debug({ error }); // remove in production
  if (error.response?.data?.message) {
    return error.response.data.message;
  } else if (error.data?.message) {
    return error.data.message;
  } else if (error.message) {
    return error.message;
  }
  return error;
};
